export default "__VITE_ASSET__00bcf5b5__"